import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  TOUR_DOM_EVENTS,
  type TourNavigateDetail,
} from './onboardingDomEvents';

/** Listens for tour-initiated SPA navigations (mission fallbacks, lab route steps). */
export const TourNavigationBridge: React.FC = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const handler = (event: Event) => {
      const detail = (event as CustomEvent<TourNavigateDetail>).detail;
      const path = detail?.path?.trim();
      if (!path) {
        return;
      }
      navigate(path, { replace: detail.replace === true });
    };

    window.addEventListener(TOUR_DOM_EVENTS.NAVIGATE, handler as EventListener);
    return () =>
      window.removeEventListener(
        TOUR_DOM_EVENTS.NAVIGATE,
        handler as EventListener,
      );
  }, [navigate]);

  return null;
};

export default TourNavigationBridge;
